module.exports = __webpack_public_path__ + "static/media/forexams1-icon.33c9ef58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/forexams1-icon.svg
// module id = 2870
// module chunks = 0